import SignedIn from '@jumbo/components/Common/authComponents/SignedIn';
import React from 'react';

const AuthenticateToken = () => <SignedIn variant="default" wrapperVariant="bgColor" />;

export default AuthenticateToken;
